import { API_URL } from '../config';
import type { Variant } from './variant';

let landingViewFired = false;

const VARIANT_LANDING_PATH: Record<Variant, string> = {
  launch: '/landing/view',
  install: '/landing/install',
  start: '/landing/start',
};

export function fireLandingView(variant: Variant): void {
  if (landingViewFired) return;
  landingViewFired = true;
  const body = {
    path: VARIANT_LANDING_PATH[variant],
    query_string: window.location.search.replace(/^\?/, '') || null,
    screen_width: window.screen?.width ?? null,
    screen_height: window.screen?.height ?? null,
  };
  fetch(`${API_URL}/analytics/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => { /* swallow */ });
}

const firedFtueBubbles = new Set<string>();

export function fireFtueBubble(key: string): void {
  if (firedFtueBubbles.has(key)) return;
  firedFtueBubbles.add(key);
  fetch(`${API_URL}/analytics/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ path: `/ftue/${key}` }),
    keepalive: true,
  }).catch(() => { /* swallow */ });
}

export function fireAnalyticsEvent(name: string, metadata?: Record<string, unknown>): void {
  const body = { name, metadata: metadata ?? {} };
  fetch(`${API_URL}/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => { /* swallow */ });
}

export function submitInstallInterest(email: string, variant: Variant): Promise<Response> {
  return fetch(`${API_URL}/analytics/install-interest`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, variant }),
    keepalive: true,
  });
}
